import { Form } from "@redriver/cinnamon-mui";
import { getEnquiries } from "./actions";

const EnquiryTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getEnquiries} />
);

export default EnquiryTypeAhead;
